module.exports = __webpack_public_path__ + "img/imaginative-mind.cf0b795b.svg";